import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Link,
  useRouteMatch,
  NavRoute,
  NavLink,
  useHistory,
} from "react-router-dom";
import { Nav, NavItem, Collapse } from "reactstrap";
import Organization from "../../../../../images/building.png";
import Profile from "../../../../../images/user.png";
import { logout } from "../../../../../redux/actions/user";
import Team from "../../../../../images/exp/group.png";
import { changeActiveTab } from "../../../../../redux/actions/skill";
import home from "../../../../../images/home.png";
import deviceIcon from "../../../../../images/devices.svg";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import { getCurrentUser } from "../../../../../redux/actions/organizationAction";
import $ from "jquery"
const SettingSidebar = (props) => {
  const email = useSelector((state) => state.userReducer?.user?.email);
  const groupPlan = useSelector((state) => state.userReducer?.groupPlan?.type);
  const [isOpen, setIsOpen] = useState(true);

  const toggle = async () => {
    await setIsOpen(!isOpen);
  };
  const history = useHistory();
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const currentUser = useSelector(
    (state) => state.organizationReducer?.currentOrgUser
  );
  const isAdmin = useSelector(
    (state) => state.organizationReducer?.currentOrganization?.isAdmin
  );

  useEffect(() => {
    $('.secondary-nav').on("click", function(){
      $('.inner-left-sidebar').removeClass('active');
    });
    dispatch(getCurrentUser(email));
    return () => {};
  }, [email]);

  useEffect(() => {
  $('.secondary-nav').on("click", function(){
    $('.inner-left-sidebar').removeClass('active');
    $('.fixed-bar').removeClass('active');
  });
})

  return (
    <>
      <Nav className="secondary-nav" vertical>
        <NavItem>
          <Link
            // onClick={toggle}
            // to="/settings/profile/my-profile"
            to="/settings/profile/account"
            className="text-dark"
          >
            <div className="d-flex align-items-center">
              <div className="holder-label">
                <img src={Profile} alt="Profile" />
              </div>
              <span>My Profile Settings</span>
            </div>
          </Link>
          <Collapse isOpen={true}>
            <Nav className="profile-setting-link" vertical>
              {/* <NavItem>
                <NavLink
                  className=""
                  to="/settings/profile/my-profile"
                >
                  My Profile
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="pl-5"
                  to="/assistant-setting"
                  isActive={(match) => match}
                >
                  Assistant Setting
                </NavLink>
              </NavItem> */}
              <NavItem>
                <NavLink
                  className="pl-5"
                  to="/settings/profile/account"
                  isActive={(match) => match}
                >
                  {/* Account Setting */}
                  Edit Profile
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className="pl-5"
                  to="/settings/profile/change-password"
                  isActive={(match) => match}
                >
                  Change Password
                </NavLink>
              </NavItem>
              {/* <NavItem>
                <NavLink
                  className="pl-5"
                  to="/notification-setting"
                  isActive={(match) => match}
                >
                  Notification Setting
                </NavLink>
              </NavItem> */}
            </Nav>
          </Collapse>
        </NavItem>
        {/* Renaming Organization to Teams */}

        <NavItem className={path == "/settings/teams/" ? "active" : ""}>
          <Link
            // onClick={() => setIsOpen(false)}
            onClick={toggle}
            to="/settings/teams"
            className="text-dark"
          >
            <div className="d-flex align-items-center">
              <div className="holder-label">
                <img src={Organization} alt="Organization" />
              </div>
              <span>Teams Settings</span>
            </div>
          </Link>
        </NavItem>
        {isAdmin ? (
          <NavItem className={path == "/settings/billing" ? "active" : ""}>
            <Link
              // onClick={() => setIsOpen(false)}
              onClick={toggle}
              to="/settings/billing"
              className="text-dark"
            >
              <div className="d-flex align-items-center">
                <div className="holder-label">
                  <img src={Organization} alt="Organization" />
                </div>
                <span>Billing/Subscriptions</span>
              </div>
            </Link>
          </NavItem>
        ) : null}

        {process.env.REACT_APP_ADMIN1 === email ||
        process.env.REACT_APP_ADMIN2 === email ||
        process.env.REACT_APP_ADMIN3 === email ||
        process.env.REACT_APP_ADMIN4 === email ? (
          <NavItem
            className={
              path == "/settings/profile/analytics/admin" ? "active" : ""
            }
          >
            <Link
              // onClick={() => setIsOpen(false)}
              onClick={toggle}
              to="/settings/profile/analytics/admin"
              className="text-dark"
            >
              <div className="d-flex align-items-center">
                <div className="holder-label">
                  <img src={Organization} alt="Organization" />
                </div>
                <span>Super Analytics</span>
              </div>
            </Link>
          </NavItem>
        ) : (
          ""
        )}

        {process.env.REACT_APP_VERSION_FLAG == "v3" ? null : (
          <NavItem className={path == "/settings/device" ? "active" : ""}>
            <Link onClick={toggle} to="/settings/device" className="text-dark">
              <div className="d-flex align-items-center">
                <div className="holder-label dc-icon">
                  <img src={deviceIcon} alt="Organization" />
                </div>
                <span>Device Settings</span>
              </div>
            </Link>
          </NavItem>
        )}
        {/* {currentUser?.role_id == 2 ? (
          <NavItem
            className={
              path ==
              `/settings/profile/analytics/${currentUser?.organization_id}`
                ? "active"
                : ""
            }
          >
            <Link
              // onClick={() => setIsOpen(false)}
              onClick={toggle}
              to={`/settings/profile/analytics/${currentUser?.organization_id}`}
              className="text-dark"
            >
              <div className="d-flex align-items-center">
                <div className="holder-label">
                  <img src={Organization} alt="Organization" />
                </div>
                <span>Analytics</span>
              </div>
            </Link>
          </NavItem>
        ) : null} */}
        {/* <NavItem
          className={path == "/settings/organization-settings/" ? "active" : ""}
        >
          <Link
            // onClick={() => setIsOpen(false)}
            onClick={toggle}
            to="/settings/organization-settings"
            className="text-dark"
          >
            <div className="d-flex align-items-center">
              <div className="holder-label mr-3">
                <img src={Organization} alt="Organization" />
              </div>
              <span>Organization Settings</span>
            </div>
          </Link>
        </NavItem> */}

        {/* {orgId && (
          <React.Fragment>
            <NavItem
              className={
                path === `/settings/organization/${orgId}/team` ? "active" : ""
              }
            >
              <Link
                to={`/settings/organization/${orgId}/team`}
                active
                className="text-dark"
              >
                <div className="d-flex align-items-center">
                  <div className="holder-label mr-3">
                    <img src={Team} alt="Organization" />
                  </div>
                  <span>Team</span>
                </div>
              </Link>
            </NavItem>
          </React.Fragment>
        )} */}

        {/* Api Tokens */}
        <NavItem className={path == "/dashboard/snippetCode" ? "active" : ""}>
          <Link
            // onClick={() => setIsOpen(false)}
            onClick={toggle}
            to="/dashboard/snippetCode"
            className="text-dark"
          >
            <div className="d-flex align-items-center">
              <div className="holder-label">
                <img src={Organization} alt="Organization" />
              </div>
              <span>API Tokens</span>
            </div>
          </Link>
        </NavItem>
      </Nav>
      <div className="logout-btn">
        <button
          className="home-btn"
          onClick={() => {
            dispatch(changeActiveTab("Create"));
            history.push("/dashboard/create");
          }}
        >
          <img src={home} />
        </button>
        <button
          onClick={() => {
            dispatch(changeActiveTab("Settings"));
            dispatch(logout());
          }}
        >
          Logout
        </button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  organizationReducer: state.organizationReducer,
  userReducer: state.userReducer,
  notifications: state.appReducer.notifications,
  notified: state.appReducer.notified,
  skillReducer: state.skillReducer,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {})
)(SettingSidebar);
